<template>
  <v-tooltip bottom v-if="timezone">
    <template v-slot:activator="{ on }">
      <v-chip
        v-on="on"
        class="no-select"
        @click="selected = selected + 1"
      >
        <v-avatar>
          <v-icon>mdi-clock</v-icon>
        </v-avatar>
        {{ timeString }}
      </v-chip>
    </template>
    <span>{{ timezone }}</span>
  </v-tooltip>
</template>

<script>
import { format, addMinutes } from "date-fns";
import { getApi } from "@/api";

export default {
  data: () => {
    return {
      interval: undefined,
      offset: 0,
      timeString: "",
      timezone: ""
    };
  },

  computed: {
    location() {
      return {
        lat: this.$route.query.lat,
        lng: this.$route.query.lng
      };
    }
  },

  methods: {
    updateClock() {
      let d = new Date();
      this.timeString = format(
        addMinutes(d, this.offset + d.getTimezoneOffset()),
        "HH:mm"
      );
    },
    fetchTimezone() {
      let params = {
        lat: this.location.lat,
        lng: this.location.lng
      };
      getApi().then(api => {
        api
          .get("geo/timezone", { params })
          .then(({ data }) => {
            let result = data.result;
            if (result) {
              let totalOffsetSeconds = data.result.dstOffset + data.result.rawOffset;
              this.offset = totalOffsetSeconds / 60;
              this.timezone = data.result.timeZoneName
            }
          })
          .catch(err => {
            console.log(err);
          });
      });
    }
  },

  props: [],

  mounted() {
    this.fetchTimezone();

    this.interval = setInterval(() => {
      this.updateClock();
    }, 1000);
  },

  destroyed() {
    clearInterval(this.interval);
  },

  watch: {
    location: {
      handler: function(val) {
        this.fetchTimezone();
      },
      immediate: true
    }
  },

  components: {}
};
</script>

<style scoped>
.no-select {
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/components/WorldClock.vue